import checkPermission from "./checkPermission";

export const canListTimeEntries = () =>
  checkPermission("list:time-entry") ||
  checkPermission("read:time-entry") ||
  checkPermission("create:time-entry") ||
  checkPermission("manage:time-entry");

export const canCreateTimeEntry = () =>
  checkPermission("create:time-entry") || checkPermission("manage:time-entry");

export const canUpdateTimeEntry = () =>
  checkPermission("update:time-entry") || checkPermission("manage:time-entry");

export const canDeleteTimeEntry = () =>
  checkPermission("delete:time-entry") || checkPermission("manage:time-entry");

export const canAccessTimeEntriesMenu = () =>
  checkPermission("menu:time-entry") || canListTimeEntries();
